import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { DropdownItem } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  tenants: ITenant[];
}

const MainNavBarTenantsLinks: React.FC<IParams> = ({ tenants }) => {
  const rootStore = useContext(RootStoreContext);
  const { isOfflineModeEnabled } = rootStore.commonStore;
  const [t] = useTranslation(["translation", "nativeapp"], translationHookOptions);
  
  return (
    <>
      {isOfflineModeEnabled ? (
        <>
          {tenants &&
            tenants.map((tenant) => (
              <DropdownItem tag={Link} to={`${tenant.path}/meetings`} key={tenant.id}>
                {t("navbar_dropdown_goto")} {tenant.name} - {t("navbar_dropdown_goto_offline", { ns : "nativeapp"})}
              </DropdownItem>
            ))}
        </>
      ) : (
        <>
          {tenants &&
            tenants.map((tenant) => (
              <DropdownItem tag="a" href={`/player${tenant.path}`} key={tenant.id}>
                {t("navbar_dropdown_goto")} {tenant.name}
              </DropdownItem>
            ))}
        </>
      )}
      <DropdownItem divider />
    </>
  );
};

export default observer(MainNavBarTenantsLinks);
